module.exports = __webpack_public_path__ + "img/TX.c76a92ce.png";